var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.items.length
        ? _c(
            "div",
            { staticClass: "p-3" },
            [
              _c(
                "time-line",
                { staticClass: "px-3" },
                _vm._l(_vm.items, function(item) {
                  return _c(
                    "time-line-item",
                    {
                      key: item.id,
                      attrs: { icon: "fas fa-exchange-alt" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "date",
                            fn: function() {
                              return [
                                _c("span", { staticClass: "data-name" }, [
                                  _vm._v("Fecha:")
                                ]),
                                _c(
                                  "p",
                                  { staticClass: "color-black font-16" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$formatDate(
                                            item.createdDate,
                                            _vm.$templateDate.longDateWithHour
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c("div", { staticClass: "row align-items-center" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md" },
                          [
                            _c("div", { staticClass: "data-name" }, [
                              _vm._v("Estatus:")
                            ]),
                            _c("custom-balloon", {
                              staticClass: "text-nowrap",
                              attrs: {
                                "background-color": item.status?.color,
                                dot: "",
                                text: item.status?.name
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-12 col-md" }, [
                          _c("div", { staticClass: "data-name" }, [
                            _vm._v("Usuario:")
                          ]),
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("capitalize")(item.userFullName)
                                ) +
                                " "
                            )
                          ])
                        ]),
                        item.comment
                          ? _c(
                              "div",
                              {
                                staticClass: "col-12 mt-3 bg-white rounded p-3"
                              },
                              [
                                _c("div", { staticClass: "data-name" }, [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-info-circle mr-2 text-orange"
                                  }),
                                  _vm._v(" Comentario: ")
                                ]),
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("empty")(item.comment)) +
                                      " "
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                1
              ),
              _vm.hasMore
                ? _c(
                    "div",
                    { staticClass: "my-4 d-flex justify-content-center" },
                    [
                      _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-chevron-down",
                            variant: "outline-success rounded-pill"
                          },
                          on: { click: _vm.load }
                        },
                        [_vm._v(" Ver más ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _c("custom-result-not-found", {
            attrs: { text: "No hay Información Disponible." }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }